var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmojiBad = function SvgEmojiBad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 18c0-9.941-8.059-18-18-18S0 8.059 0 18s8.059 18 18 18 18-8.059 18-18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M35 18c0-9.389-7.611-17-17-17S1 8.611 1 18s7.611 17 17 17 17-7.611 17-17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.68 23.623a.9.9 0 0 1 0-1.212.735.735 0 0 1 1.118 0c1.53 1.66 4.08.791 6.775-.158 2.842-1 5.78-2 7.772.158a.9.9 0 0 1-.251 1.402.735.735 0 0 1-.867-.19c-1.31-1.423-3.69-.606-6.192.264a16 16 0 0 1-4.93 1.16 4.46 4.46 0 0 1-3.425-1.424m11.778-8.935a.8.8 0 0 1-.777-.844.82.82 0 0 1 .777-.843h3.765a.8.8 0 0 1 .777.843.8.8 0 0 1-.752.844zm-11.68 0a.8.8 0 0 1-.779-.844.8.8 0 0 1 .778-.843h3.764a.82.82 0 0 1 .8.843.82.82 0 0 1-.8.844z"
  })));
};
export default SvgEmojiBad;